module.exports = __webpack_public_path__ + "static/media/diceSet.dec08df2.png";